module.exports = __webpack_public_path__ + "img/safari.1e6a644.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/browsers/safari.png
// module id = GWqI
// module chunks = 39 44